import { useEffect } from 'react';
import { StageVisit } from '../lib/cuiUsage';

export function useStageUsage(stageId?: string, house?: string): void {
  useEffect(() => {
    if (!stageId) return;
    let visit = new StageVisit(stageId, house);
    let away = false;
    const visibility = () => { if (document.hidden) visit.hide('tab_hidden'); else if (!away) visit.show(); };
    const pagehide = () => { away = true; visit.leave('pagehide'); };
    const pageshow = () => { if (away) visit = new StageVisit(stageId, house); away = false; visibility(); };
    visibility();
    const timer = setInterval(() => visit.heartbeat(), 15000);
    document.addEventListener('visibilitychange', visibility);
    window.addEventListener('pagehide', pagehide);
    window.addEventListener('pageshow', pageshow);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', visibility);
      window.removeEventListener('pagehide', pagehide);
      window.removeEventListener('pageshow', pageshow);
      visit.leave('stage_change_or_close');
    };
  }, [stageId, house]);
}
